import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { getAuditAsync,updatePagination } from "./AccountAuditSlice";
import { KTIcon, useDebounce } from '../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../common/Pagination";
import { paginationStyles } from "../../common/timeLiveFunction";
import { getPageSizeArray } from "../../common/timeLiveFunction";
import { getFilteredList,sortData, getValueFromResource } from "../../common/timeLiveFunction";
import AccountAuditItem from "./AccountAuditItems";
import Loader from "../../common/Loader";
import PageSizeSelect from "../../common/PageSizeSelect";
import fetchAPI from '../../common/fetchAPI';

const AccountAudit=(props: any)=>{

    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { accountAuditList, isReload, isLoading,sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.audit);
    const { pageId, menuList,maxMenuHeight, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const location = useLocation();
    const { obj } = location.state || {};
    document.title = obj.Title + ` | Livetecs`;

    useEffect(() => {
        if (isReload) {
            dispatch(getAuditAsync({TableName:obj.TableName, Id:obj.Id}));
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getAuditAsync({TableName:obj.TableName, Id:obj.Id}));
    }, [dispatch])

    useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync();
    }, [])

    const getMasterEntityTypeId = (tableName: string) => {
        switch (tableName) {
            case "AccountParty":
                return 'E448AED9-EAB5-4CF7-A171-2A86BE2BBA9E';
            case "AccountEmployeeExpenseSheet":
                return 'A55DF02B-FBFB-4873-B582-6968FBAEE589';
            case "AccountExpenseEntry":
                return '756E4460-A713-4BEE-B3F0-708FC5BE21BD';
            case "AccountProjectTask":
                return 'C9A8F7F1-1B2D-48DA-AAE9-74F92892A896';
            case "AccountEmployee":
                return '3601AE9B-3F82-4C80-9574-751F9A124FA8';
            case "AccountProject":
                return '13DBFF37-A092-4AE2-A919-775CBED0EDC0';
            case "AccountEmployeeTimeEntryPeriod":
                return '369ED0FB-D317-4244-9F20-B7D834521E2B';
        }
    }
    
    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId = getMasterEntityTypeId(obj.TableName);
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }

    // const handlePageChange = (pageNumber: any) => {
    //     // setCurrentPage(pageNumber);
    // };
    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     // setSearchTerm(value);
    //     // setCurrentPage(1);
    // };

    // const handlePageSizeChange = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     // setPageSize(Number(value));
    //     // setCurrentPage(1);
    // };

    // const filteredData: any = getFilteredList(Object.values(accountAuditList), searchTerm);

    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = accountAuditList.length;
    // const recordsFiltered = Object.values(filteredData).length;

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    
    const filteredData: any = getFilteredList(Object.values(accountAuditList), search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = accountAuditList.length;
    const recordsFiltered = filteredData.length;


    return (
        <>
          {isLoading && <Loader />}
                <div className="card card-custom admin-card">
                    <div className="card-header sticky-top bg-white">
                        <h3 className="card-title fw-bold headerTitle"  >
                            {/* {t(obj.Title)} */}
                            {getValueFromResource((obj.Title),dispatch, t)}
                            </h3>
                        <div className="card-toolbar align-items-center">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    value={search}
                                    onChange={handleSearch}
                                    // {t('Search')}
                                    placeholder={getValueFromResource('Search',dispatch, t)}
                                    className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                    data-kt-user-table-filter="search"
                                />
                                <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </div>
                            <div className='h-35px w-1px mx-1'></div>
                            <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={paginationStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'

                                /> */}
                                 <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <div>
                                {(currentItems.length > 0) ? (
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    >
                                    </CustomPagination>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {/* <div className="card-body"> */}
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <AccountAuditItem accountAuditList={currentItems} t={t} customFieldsArrayP={customFieldsArray}/>
                        </div>
                    </div>
                 </div>
            
        </>
    )

   
}

export default AccountAudit;